import React from 'react';
import { MarketValue } from '../../../MarketValue/MarketValue';
import { Card } from '../../../../../CommonComponents/OPL/Card/Card';

export const MarketValueCard = React.memo(() => {
  return (
    <Card p="16">
      <MarketValue />
    </Card>
  );
});
